import {
  AccountProductEnum,
  ExternalPlaidAccount,
  IAccount,
  InternalAdvanceAccount,
  InternalChargeCardAccount,
  InternalCheckingAccount,
  InternalSavingsAccount,
  Typenames,
  VaroAdvanceProductsNotQualified,
  VaroAdvanceProductsQualified,
  VaroAdvanceProductsResult,
} from '@varo/graphql-schema-types';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';

export const isQualified = (
  advanceProduct: VaroAdvanceProductsResult | undefined | null,
): advanceProduct is VaroAdvanceProductsQualified => {
  if (!advanceProduct) {
    return false;
  }
  return advanceProduct?.__typename === Typenames.VaroAdvanceProductsQualified;
};

export const isNotQualified = (
  advanceProduct: VaroAdvanceProductsResult | undefined | null,
): advanceProduct is VaroAdvanceProductsNotQualified => {
  if (!advanceProduct) {
    return false;
  }
  return (
    advanceProduct?.__typename === Typenames.VaroAdvanceProductsNotQualified
  );
};

export const isPartiallyQualifiedAdvanceAccount = (
  account?: IAccount,
): account is InternalAdvanceAccount => {
  return (
    account?.product === AccountProductEnum.Advance &&
    'reEligiblityDetail' in account &&
    isNotNil(account.reEligiblityDetail)
  );
};

export type AccountProducts =
  | InternalAdvanceAccount
  | ExternalPlaidAccount
  | InternalCheckingAccount
  | InternalSavingsAccount
  | InternalChargeCardAccount
  | IAccount
  | undefined;

export const isAdvanceAccount = (
  account: AccountProducts,
): account is InternalAdvanceAccount => {
  if (account?.product !== AccountProductEnum.Advance) {
    return false;
  }
  return account?.product === AccountProductEnum.Advance;
};
